<template>
  <div>
    <vuetable
      ref="vuetable"
      :api-url="url"
      :httpOptions="options"
      :fields="fields"
      :query-params="makeQueryParams"
      pagination-path=""
      @vuetable:pagination-data="onPaginationData"
    ></vuetable>
    <div class="vuetable-pagination ui basic segment grid">
      <vuetable-pagination-info ref="paginationInfo"></vuetable-pagination-info>
      <bulma-pagination
        ref="pagination"
        @vuetable-pagination:change-page="onChangePage"
      ></bulma-pagination>
    </div>
  </div>
</template>


<script>
import moment from "moment";

import Vuetable from "vuetable-2/src/components/Vuetable";
import BulmaPagination from "../BulmaPagination";
import VuetablePaginationInfo from "vuetable-2/src/components/VuetablePaginationInfo";

export default {
  props: ["url", "type"],
  components: {
    Vuetable,
    BulmaPagination,
    VuetablePaginationInfo,
  },
  data() {
    return {
      isLoading: false,
      options: {
        headers: { Authorization: window.localStorage.getItem("biyadmin") },
      },
      fields: [
        {
          name: "phone",
          title: "Phone",
        },
                {
          name: "network",
          title: "Network",
        },
        {
          name: "status",
          title: "Status",
        },

        {
          name: "amount",
          title: "Amount",
        },
        {
          name: "updatedAt",
          title: "Date",
          callback: "formatDate|DD/MMM HH:mm",
        },
      ],
    };
  },
  methods: {
    formatDate(value, fmt = "D MMM YYYY") {
      return value == null ? "" : moment(value).format(fmt);
    },
    onPaginationData(paginationData) {
      this.$refs.pagination.setPaginationData(paginationData);
      this.$refs.paginationInfo.setPaginationData(paginationData);
    },
    onChangePage(page) {
      this.$refs.vuetable.changePage(page);
    },
    makeQueryParams() {
      return {
        type: this.type,
      }
    }
  },
};
</script>


// WEBPACK FOOTER //
// BatchTable.vue?21aed8fa